import {Mapper} from '@s-ui/domain'

export class TrackingRecommendationsMapper extends Mapper {
  constructor({
    config,
    fromPageTrackingJsonToTrackingDataValueObjectMapper,
    fromPageTrackingJsonToAdvertisementsValueObjectMapper
  }) {
    super()
    this._config = config
    this._recommendationsPageListTypesByTarget = this._config.get('tracking').RECOMMENDATIONS_PAGE_LIST_TYPES_BY_TARGET
    this._fromPageTrackingJsonToTrackingDataValueObjectMapper = fromPageTrackingJsonToTrackingDataValueObjectMapper
    this._fromPageTrackingJsonToAdvertisementsValueObjectMapper = fromPageTrackingJsonToAdvertisementsValueObjectMapper
  }

  map = ({culture, data, page}) => {
    const {origin, products} = data

    const listType = this._recommendationsPageListTypesByTarget[origin]

    const productsVO = this._fromPageTrackingJsonToAdvertisementsValueObjectMapper
      .setParams({adsTypeName: 'ad_impression', listType})
      .map({ads: products})

    const trackingData = {
      list_type: listType,
      products: productsVO.toJSON()
    }

    return this._fromPageTrackingJsonToTrackingDataValueObjectMapper
      .setParams({
        page,
        culture
      })
      .map(trackingData)
  }
}
